import { CommunicationService } from './../common/communication.service';
import { CashFlowTableComponent } from './../trade/cash-flow/cash-flow-table/cash-flow-table.component';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { AwsUtil, WebAPIConfig } from './../authentication/aws.service';
import { Observable, Observer } from 'rxjs';
import { AppConfig } from './../app.config';
import { SnapshotService } from './../snapshot/snapshot.service';
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {
    WebApiEndpoints,
    HealthCheckRequest,
    HealthCheckResponse,
    FileStatus,
    SweepInstruction,
    GetSweepInstructions,
    getHivePartitionDateFolders,
    GetOpeningDataRequest,
    InterestBasedProductCashFlow,
    GetTradeCashFlowsRequest,
    AdminBatchProcessRequest,
    BATCH_PROCESS_SYSTEM_ACTION_CHECK_DB_AVAILABILITY,
    BATCH_PROCESS_ACTION_RESET,
    BATCH_PROCESS_ACTION_STATUS,
    GetAthenaResultsRequest
} from '@liquitics/transaction';
import { createSerialChart } from '../dashboard/dashboard-graphical-chart-generator';
import * as moment from 'moment';
import { MenuItem, SelectItem } from 'primeng/api';


const ATHENA_QUERIES = [
    {
        queryName: 'OpeningProjection',
        columnNames: ['type', 'settle_date', 'projection_cutoff_time', 'desk', 'target_type', 'target_name', 'product_type', 'product', 'currency', 'direction', 'amount', 'account'],
    },
    {
        queryName: 'SODContractual',
        columnNames: ['settle_date', 'product_type', 'desk', 'amount', 'currency', 'direction', 'client_group'],
    },
    {
        queryName: 'OpeningBalanceByDesk',
        columnNames: ['desk', 'currency', 'amount'],
    },
    {
        queryName: 'OpeningBalanceByAccount',
        columnNames: ['account', 'currency', 'amount'],
    },
    {
        queryName: 'OpeningNostroBalanceByDesk',
        columnNames: ['currency', 'account', 'desk', 'balance'],
    },
    {
        queryName: 'OpeningNostroProjection',
        columnNames: ['balance_type', 'currency', 'account', 'client_group', 'product', 'amount'],
    },
    {
        queryName: 'DeskForecast',
        columnNames: ['settle_date', 'desk', 'currency', 'amount'],
    },
    {
        queryName: 'ClientForecast',
        columnNames: ['settle_date', 'client_group', 'currency', 'amount'],
    },
    {
        queryName: 'SecuritiesPositions',
        columnNames: ['isin', 'currency', 'position_type', 'position_0d', 'position_1d', 'position_2d', 'position_3d', 'position_4d', 'position_5d', 'position_6d', 'sector', 'rating', 'country', 'remaining_maturity_tenor', 'next_coupon_date', 'special_collateral_type', 'next_corporate_action_date', 'bond_type', 'bond_yield', 'stability_type'],
    },
    {
        queryName: 'TopLadderFlow',
        columnNames: ['flow_key', 'event_datetime', 'settle_date', 'direction', 'currency', 'amount', 'organization_level', 'desk', 'trade_datetime', 'account', 'client', 'client_group', 'supplementary_ref', 'product', 'product_type', 'clearing', 'source', 'external_id', 'secondary_id', 'flow_scope', 'flow_type', 'pay_client_account', 'rec_client_account'],
    },
];

// const COLUMN_NAMES = {
//     'accountbalance': ['Account', 'Currency', 'Amount'],
//     'clientforecast': ['Date', 'Client', 'Currency', 'Amount'],
//     'contractual': ['Settle Date', 'Product Type', 'Desk', 'Amount', 'Currency', 'Direction'],
//     'deskbalance': ['Desk', 'Currency', 'Amount'],
//     'lorobalance': ['Currency', 'Loro Account', 'Balance'],
//     'nostroprojection': ['Balance Type', 'Currency', 'Account', 'Client Group', 'Product', 'Start Balance'],
//     'tenordate': ['Currency', 'Tenor', 'Tenor Date'],
//     'projection': ['Type', 'Settle Date ', 'Cutoff Time', 'Desk', 'Target Type',
//         'Target Name', 'Product Type', 'Product', 'Currecny', 'Direction', 'Amount', 'Account'],
//     'assumptioncandidatesfx': ['Flow Key', 'Client', 'Direction', 'Currency', 'Amount', 'Account', 'Product',
//         'Product Type', 'External ID', 'Flow Type', 'Original Tenor', 'Maturity Date', 'Remaining Maturity', 'Desk',
//         'Organization', 'Security'],
//     'assumptioncandidatesmm': ['Flow Key', 'Client', 'Direction', 'Currency', 'Amount', 'Account', 'Product',
//         'Product Type', 'External ID', 'Flow Type', 'Original Tenor', 'Maturity Date', 'Remaining Maturity', 'Desk',
//         'Organization', 'Security'],
//     'assumptioncandidatesrepo': ['Flow Key', 'Client', 'Direction', 'Currency', 'Amount', 'Account', 'Product',
//         'Product Type', 'External ID', 'Flow Type', 'Original Tenor', 'Maturity Date', 'Remaining Maturity', 'Desk',
//         'Organization', 'Security'],
//     'assumptioncandidatesdeposit': ['Flow Key', 'Client', 'Direction', 'Currency', 'Amount', 'Account', 'Product',
//         'Product Type', 'External ID', 'Flow Type', 'Original Tenor', 'Maturity Date', 'Remaining Maturity', 'Desk',
//         'Organization', 'Security'],
//     'assumptionflowsfx': ['Run Date', 'Date', 'Original Amount', 'Assumed Amount', 'Currency', 'Desk', 'Organization',
//         'Cut Off Time', 'Client', 'Assumption Rule', 'Account', 'Internal', 'Assumption Percent', 'Direction', 'Reference Group',
//         'Scenario', 'Assumption Type', 'Reason', 'Product', 'Product Type', 'Flow Key'],
//     'assumptionflowsmm': ['Run Date', 'Date', 'Original Amount', 'Assumed Amount', 'Currency', 'Desk', 'Organization',
//         'Cut Off Time', 'Client', 'Assumption Rule', 'Account', 'Internal', 'Assumption Percent', 'Direction', 'Reference Group',
//         'Scenario', 'Assumption Type', 'Reason', 'Product', 'Product Type', 'Flow Key'],
//     'assumptionflowsdeposit': ['Run Date', 'Date', 'Original Amount', 'Assumed Amount', 'Currency', 'Desk', 'Organization',
//         'Cut Off Time', 'Client', 'Assumption Rule', 'Account', 'Internal', 'Assumption Percent', 'Direction', 'Reference Group',
//         'Scenario', 'Assumption Type', 'Reason', 'Product', 'Product Type', 'Flow Key'],
//     'assumptionflowsrepo': ['Run Date', 'Date', 'Original Amount', 'Assumed Amount', 'Currency', 'Desk', 'Organization',
//         'Cut Off Time', 'Client', 'Assumption Rule', 'Account', 'Internal', 'Assumption Percent', 'Direction', 'Reference Group',
//         'Scenario', 'Assumption Type', 'Reason', 'Product', 'Product Type', 'Flow Key'],
//     'alreadyoccurredassumptioncandidates': ['Settle Date', 'Amount', 'Currency', 'Organization', 'Client', 'Product Type', 'Product',
//         'Account', 'Direction', 'Desk'],
//     'historicaldatescorporate': ['Currency', 'Rule Name', 'Prediction Type', 'Calculation Method', 'Product Type', 'Product',
//         'Client Group', 'Desk', 'Organization', 'Anchor Date', 'Historical Txn Date', 'Weight'],
//     'historicaldatesbanking': ['Currency', 'Rule Name', 'Prediction Type', 'Calculation Method', 'Product Type', 'Product',
//         'Client Group', 'Desk', 'Organization', 'Anchor Date', 'Historical Txn Date', 'Weight']
// }

// const FILES = [
//     { prefix: 'accountbalance', title: 'Account Balance' },
//     { prefix: 'clientforecast', title: 'Client Forecast' },
//     { prefix: 'contractual', title: 'Contractual' },
//     { prefix: 'deskbalance', title: 'Desk Balance' },
//     { prefix: 'deskforecast', title: 'Desk Forecast' },
//     { prefix: 'lorobalance', title: 'Loro Balance' },
//     { prefix: 'nostroprojection', title: 'Nostro Projection' },
//     { prefix: 'tenordate', title: 'Tenor Date' },
//     { prefix: 'projection', title: 'Projection' },
//     { prefix: 'assumptioncandidatesdeposit', title: 'Assumption Candidates(Deposit)' },
//     { prefix: 'assumptioncandidatesfx', title: 'Assumption Candidates(FX)' },
//     { prefix: 'assumptioncandidatesmm', title: 'Assumption Candidates(MM)' },
//     { prefix: 'assumptioncandidatesrepo', title: 'Assumption Candidates(Repo)' },
//     { prefix: 'assumptionflowsdeposit', title: 'Assumption Flows(Deposit)' },
//     { prefix: 'assumptionflowsfx', title: 'Assumption Flows(FX)' },
//     { prefix: 'assumptionflowsmm', title: 'Assumption Flows(MM)' },
//     { prefix: 'assumptionflowsrepo', title: 'Assumption Flows(Repo)' },
//     { prefix: 'alreadyoccurredassumptioncandidates', title: 'Already Occurred Assumption Candidates' },
//     { prefix: 'historicaldatesCORPORATE', title: 'Historical Dates Corporate Predictions' },
//     { prefix: 'historicaldatesBANKING', title: 'Historical Dates Banking Predictions' },
// ];

@Component({
    selector: 'app-eod',
    templateUrl: './eod.component.html',
    styleUrls: ['./eod.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EodComponent implements OnInit {
    loading = false;
    batchIdentifier: string;

    menuItems: MenuItem[];
    openingFilesMenuItems;
    selectedColumns: any[];

    displayType: 'OpeningFile' | 'WarehouseProgress' | 'HealthCheck' | 'SweepInstructions' | 'LoanCashFlows' | 'UploadLoanTradeFile';
    selectedQueryName: string;

    columnAndTableDataByType: any;
    errorMessagesByType: any;
    output: string;

    yesterdaysHealthCheckResults: HealthCheckResults;
    currentHealthCheckResults: HealthCheckResults;

    sweepInstructions: SweepInstruction[];

    eodDetailsCols: any[];
    eodTaskStatuses: SelectItem[];

    queryTradeId: string;
    @ViewChild(CashFlowTableComponent, {static: true}) cashFlowTableComponent: CashFlowTableComponent;

    constructor(private snapshotService: SnapshotService,
        private appConfig: AppConfig,
        private awsUtil: AwsUtil,
        private amChartsService: AmChartsService,
        private communicationService: CommunicationService,
    ) {
    }

    ngOnInit() {
        this.batchIdentifier = this.snapshotService.applicationConfiguration.batchIdentifiers
            .filter((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.startsWith('ALM') && modeBatchIdentifier.endsWith('EOD');
            })
            .map((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.split('=')[1];
            })[0];
        const operatingDate = this.appConfig.getTodayString();
        const todayFolder = getHivePartitionDateFolders(operatingDate);
        this.output = '';
        // const fileNames = FILES.map((entry) => {
        //     return `opening/${entry.prefix}/${todayFolder}/${entry.prefix}.csv000`;
        // })
        // const dataNames = FILES.map((entry) => {
        //     return entry.prefix.toLowerCase();
        // })
        // const observer = {
        //     next: (message: string) => { }
        // } as Observer<string>;

        this.columnAndTableDataByType = {};
        this.errorMessagesByType = {};
        this.initMenu();
        this.initOpeningFilesMenu();
        // Promise.all(dataNames.map((dataName: string) => {
        //     const params = {
        //         openingDate: this.appConfig.getTodayString(),
        //         dataName: dataName,
        //     } as GetOpeningDataRequest;
        //     return this.awsUtil.webAPICall(WebApiEndpoints.QueryOpeningData, params, false)
        //         .catch((err: Error) => {
        //             return err;
        //         })
        //     // return this.snapshotService.loadSnapshotData(fileName, observer, false)
        //     //     .then((results: any[]) => {
        //     //         return results;
        //     //     })
        //     //     .catch((err) => {
        //     //         console.log(err);
        //     //         // We want to keep going for the other files even if one fails
        //     //         return [];
        //     //     })
        // })
        // )
        //     .then((results: (any | Error)[]) => {
        //         results.forEach((result: any | Error, index: number) => {
        //             if (result instanceof Error || result instanceof HttpErrorResponse) {
        //                 console.log(result);
        //                 this.errorMessagesByType[FILES[index].prefix] = JSON.stringify(result, null, 2);
        //             } else {
        //                 const colAndTableData = this.generateColumnsAndTableData(FILES[index].prefix, result);
        //                 if (colAndTableData.columns) {
        //                     this.columnAndTableDataByType[FILES[index].prefix] = colAndTableData;
        //                 }
        //             }
        //         })
        //         this.filePrefixes = FILES.map((entry) => entry.prefix);
        //         this.initOpeningFilesMenu();
        //         this.refreshHealthCheck();
        //     });

        this.eodDetailsCols = [
            { field: 'task_order', width: '1em', header: 'Order' },
            { field: 'task_name', width: '12em', header: 'Task' },
            { field: 'status', width: '3em', header: 'Status' },
            { field: 'start_datetime', width: '3em', header: 'Start' },
            { field: 'finish_datetime', width: '3em', header: 'End' },
            { field: 'duration', width: '3em', header: 'Duration(s)' },
            { field: 'message', width: '10em', header: 'Message' },
            { field: 'failure_count', width: '3em', header: 'Fail Count' },
        ];
        this.eodTaskStatuses = [
            { label: 'SUCCESS', value: 'SUCCESS' },
            { label: 'PENDING', value: 'PENDING' },
            { label: 'FAILED', value: 'FAILED' },
        ]
    }

    refresh() {
        this.loading = true;
        if (this.displayType === 'SweepInstructions') {
            this.refreshSweepInstructions();
        } else if (this.displayType === 'OpeningFile') {
            this.refreshOpeningFiles(this.selectedQueryName);
        }
    }

    refreshOpeningFiles(queryName: string) {
        const params = {
            queryName: queryName,
            batchIdentifier: this.batchIdentifier
        } as GetAthenaResultsRequest;
        this.awsUtil.webAPICall(WebApiEndpoints.BatchQuery, params, false)
            .then((results: (any | Error)[]) => {
                if (results instanceof Error || results instanceof HttpErrorResponse) {
                    console.log(results);
                    this.errorMessagesByType[queryName] = JSON.stringify(results, null, 2);
                } else {
                    const colAndTableData = this.generateColumnsAndTableData(queryName, results);
                    if (colAndTableData.columns) {
                        this.columnAndTableDataByType[queryName] = colAndTableData;
                    }
                    this.selectedColumns = this.getSelectedOpeningTableColumns();
                }
                this.loading = false;
            })
    }

    refreshHealthCheck() {
        const currentHCRequest = {
            timing: 'Current'
        } as HealthCheckRequest;
        const yesterdayHCRequest = {
            timing: 'AsOf',
            asOfDate: moment(this.appConfig.getTodayString()).subtract(1, 'day').format('YYYY-MM-DD')
        } as HealthCheckRequest;
        this.awsUtil.webAPICall(WebApiEndpoints.QueryHealthChecks, yesterdayHCRequest)
            .then((response: HealthCheckResponse) => {
                this.decorateHealthCheckResponse(response);
                this.yesterdaysHealthCheckResults = new HealthCheckResults();
                this.yesterdaysHealthCheckResults.healthCheckResponse = response;
                this.yesterdaysHealthCheckResults.healthCheckResponseStr = JSON.stringify(response);
                this.yesterdaysHealthCheckResults.transactionS3Statuses = response
                    .transactionS3Archives
                    .map((fileStatus: FileStatus) => {
                        return { hour: fileStatus.file.substring(fileStatus.file.length - 2), exists: fileStatus.exists };
                    })
                return this.awsUtil.webAPICall(WebApiEndpoints.QueryHealthChecks, currentHCRequest)
            })
            .then((response: HealthCheckResponse) => {
                this.decorateHealthCheckResponse(response);
                this.currentHealthCheckResults = new HealthCheckResults();
                this.currentHealthCheckResults.healthCheckResponse = response;
                this.currentHealthCheckResults.healthCheckResponseStr = JSON.stringify(response);
                // console.log(JSON.stringify(response, null, 2));
                createSerialChart(this.amChartsService, 'throughputchartdiv', 'column', false,
                    false, response.transactionTimeCounts, 'time', ['count']);

                this.currentHealthCheckResults.transactionS3Statuses = response
                    .transactionS3Archives
                    .map((fileStatus: FileStatus) => {
                        return { hour: fileStatus.file.substring(fileStatus.file.length - 2), exists: fileStatus.exists };
                    })
                return this.awsUtil.webAPICall(WebApiEndpoints.QuerySweepInstructions, new GetSweepInstructions());
            })
            .then((si: SweepInstruction[]) => {
                this.sweepInstructions = si;
            })
            ;
    }

    decorateHealthCheckResponse(response: HealthCheckResponse): HealthCheckResponse {
        if (response.eodTaskProgressDetails) {
            response.eodTaskProgressDetails
                .forEach((eodTaskProgressDetail) => {
                    const start = moment.utc(eodTaskProgressDetail.start_datetime);
                    const end = moment.utc(eodTaskProgressDetail.finish_datetime);
                    eodTaskProgressDetail['duration'] = end.diff(start, 'seconds');
                });
        }
        return response;
    }

    refreshSweepInstructions() {
        this.awsUtil.webAPICall(WebApiEndpoints.QuerySweepInstructions, new GetSweepInstructions())
            .then((si: SweepInstruction[]) => {
                this.sweepInstructions = si;
                this.loading = false;
            })
            ;
    }


    generateColumnsAndTableData(queryName: string, rows: any[]) {
        const colAndTableData: any = {};
        if (rows) {
            if (rows.length > 0) {
                // Columns
                const cols = this.getHeaderColumns(queryName)
                    .map((value: string, index: number) => {
                        return { field: 'col' + index, header: this.getColumnName(queryName, index) }
                    });
                // Row Data
                const tableData = rows.map((row: any) => {
                    const rowData: any = {};
                    cols.forEach((col, index: number) => {
                        rowData['col' + index] = this.parseValue(row[col.header]);
                    });
                    return rowData;
                })
                colAndTableData['columns'] = cols;
                colAndTableData['tableData'] = tableData;
            }
        }
        return colAndTableData;
    }

    parseValue(originalValue: string): any {
        let parsedValue: any = originalValue;
        const dateRegex = /\d{4}-\d{2}-\d{2}/;
        if (dateRegex.test(originalValue)) {
            return originalValue;
        }
        parsedValue = parseFloat(originalValue);
        if (!parsedValue) {
            parsedValue = originalValue;
        }
        return parsedValue;
    }

    getHeaderColumns(queryName: string): string[] {
        const matchedQuery = ATHENA_QUERIES
            .find((query) => {
                return query.queryName === queryName;
            });
        if (!matchedQuery) {
            return [];
        }
        return matchedQuery.columnNames;
    }

    getColumnName(queryName: string, columnIndex: number) {
        const matchedQuery = ATHENA_QUERIES
            .find((query) => {
                return query.queryName === queryName;
            });
        if (!matchedQuery) {
            return '';
        }
        const names = matchedQuery.columnNames;
        if (names) {
            return names[columnIndex];
        }
        return 'Col ' + columnIndex;
    }

    getTitleName(queryName: string): string {
        const matchedQuery = ATHENA_QUERIES
            .find((query) => {
                return query.queryName === queryName;
            });
        if (!matchedQuery) {
            return '';
        }
        return matchedQuery.queryName;
    }


    initMenu() {
        this.openingFilesMenuItems = [];
        this.menuItems = [
            {
                label: 'Opening Files',
                items: this.openingFilesMenuItems
            },
            // {
            //     label: 'End of Day',
            //     items: [
            //         {
            //             label: 'Warehouse Progress',
            //             command: () => { this.displayType = 'WarehouseProgress'; }
            //         },
            //         {
            //             label: 'Health Check',
            //             command: () => { this.displayType = 'HealthCheck'; }
            //         }
            //     ]
            // },
            {
                label: 'Position Support',
                items: [
                    {
                        label: 'Sweep Instructions',
                        command: () => { this.displayType = 'SweepInstructions'; }
                    }
                ]
            }
            // ,
            // {
            //     label: 'Trade',
            //     items: [
            //         {
            //             label: 'Upload Trades',
            //             command: () => { this.displayType = 'UploadLoanTradeFile'; }
            //         },
            //         {
            //             label: 'Loan Cash Flows',
            //             command: () => { this.displayType = 'LoanCashFlows'; }
            //         }
            //     ]
            // }
        ]
    }

    initOpeningFilesMenu() {
        this.openingFilesMenuItems.push(...ATHENA_QUERIES
            .map((query) => {
                return {
                    label: this.getTitleName(query.queryName),
                    command: () => {
                        this.displayType = 'OpeningFile';
                        this.selectedQueryName = query.queryName;
                        if (this.getSelectedOpeningTableData().length === 0) {
                            this.refreshOpeningFiles(this.selectedQueryName);
                        }
                    }
                }
            })
        );
    }

    getSelectedOpeningTableData() {
        const colAndTableData = this.columnAndTableDataByType[this.selectedQueryName];
        if (colAndTableData) {
            return colAndTableData['tableData'];
        } else {
            return [];
        }
    }

    getSelectedOpeningTableColumns() {
        const colAndTableData = this.columnAndTableDataByType[this.selectedQueryName];
        if (colAndTableData) {
            return colAndTableData['columns'];
        } else {
            return [];
        }
    }

    // queryTradeCashFlows() {
    //     const request = {
    //         tradeId: this.queryTradeId
    //     } as GetTradeCashFlowsRequest;
    //     this.cashFlowTableComponent.loading = true;
    //     this.awsUtil.webAPICall(WebApiEndpoints.QueryTradeCashFlows, request)
    //         .then((cfs: InterestBasedProductCashFlow[]) => {
    //             this.cashFlowTableComponent.showCashFlows(cfs);
    //         })
    // }

    // handleLoanTradeFileUpload(event) {
    //     for (const file of event.files) {
    //         // push to s3
    //         // refresh local avatar
    //         const fileReader = new FileReader();
    //         fileReader.readAsText(file);
    //         fileReader.onload = (evt: Event) => {
    //             const body = fileReader.result.toString();
    //             const bucket = this.appConfig.getTenantInfo().bucket.replace('data', 'loan');
    //             const path = WebApiEndpoints.Import + `/${bucket}/import%2Floantrade%2Fupload%2F${file.name}`;
    //             const webAPIConfig = new WebAPIConfig();
    //             webAPIConfig.isPut = true;
    //             webAPIConfig.apiPath = path;
    //             this.awsUtil.webAPICall(webAPIConfig, body);
    //         };
    //     }
    // }

    // resetLoanTradeProcessing() {
    //     const request = {
    //         batchProcessType: 'LOAN_TRADE_CASH_FLOWS',
    //         action: BATCH_PROCESS_ACTION_RESET,
    //     } as AdminBatchProcessRequest;
    //     this.awsUtil.webAPICall(WebApiEndpoints.BatchAdmin, request, true)
    //         .then((result: any) => {
    //             this.communicationService.openSnackBar(result, 'Ok');
    //         })
    //         .catch((err) => {
    //             this.communicationService.openSnackBar(err, 'Ok');
    //         });
    // }

    //     requestLoanTradeProcessingStatus() {
    //         const request = {
    //             batchProcessType: 'LOAN_TRADE_CASH_FLOWS',
    //             action: BATCH_PROCESS_ACTION_STATUS,
    //         } as AdminBatchProcessRequest;
    //         this.awsUtil.webAPICall(WebApiEndpoints.BatchAdmin, request, true)
    //             .then((result: AWS.SQS.Types.GetQueueAttributesResult) => {
    //                 const attributes = result.Attributes;
    //                 const txt = `Msgs: ${attributes['ApproximateNumberOfMessages']},
    // Delay: ${attributes['ApproximateNumberOfMessagesDelayed']},
    // NonVis: ${attributes['ApproximateNumberOfMessagesNotVisible']}`;
    //                 this.communicationService.openSnackBar(txt, 'Ok');
    //             })
    //             .catch((err) => {
    //                 this.communicationService.openSnackBar(err, 'Ok');
    //             });
    //     }
}

export class HealthCheckResults {
    healthCheckResponse: HealthCheckResponse;
    healthCheckResponseStr: string;
    transactionS3Statuses: { hour: string, exists: boolean }[];
}
